import React from "react";

const UpdateSession = React.lazy(() => import("./UpdateSession"));
const SessionDetails = React.lazy(() => import("./SessionDetails"));
const TrainingSessions = React.lazy(() => import("./TrainingSession"));

export const sessionRoutes = [
	{
		path: "/admin/session/create",
		name: "Create workouts",
		element: <UpdateSession />,
	},
	{
		path: "/admin/session/update/:id?",
		name: "Create workouts",
		element: <UpdateSession />,
	},
	{
		path: "/admin/session/:id",
		name: "Session",
		element: <SessionDetails />,
	},
	{
		path: "/admin/personalTrainingSessions",
		name: "Training Sessions",
		element: <TrainingSessions />,
	},
];
